import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { formatNumber, ROUTES, formatDate } from '../../shared/constants'
import CustomViewForm from '../../components/CustomViewForm'
import { usePrimarySales } from '../../hooks/Sales/usePrimarySales'

export default function ViewPrimarySales() {
  const { primarySales, loading, getPrimarySales } = usePrimarySales()
  const params = useParams()
  const [data, setData] = useState([])

  useEffect(() => {
    getPrimarySales({ primarySalesId: params.primarySalesId })
  }, [params.primarySalesId])

  useEffect(() => {
    if (primarySales) {
      setData([
        { label: 'Store', data: primarySales.store && primarySales.store.name },
        { label: 'Sale Type', data: primarySales.saleType },
        { label: 'Invoice Number', data: primarySales.invoiceNumber },
        { label: 'Invoice Date', data: formatDate(primarySales.invoiceDate) },
        { label: 'Order Number', data: primarySales.orderNumber },
        { label: 'Total Amount', data: formatNumber(primarySales.amount) },
        {
          label: 'Quantity/SKU/Amount',
          data: primarySales.product.map((item) => ({ ...item, sku: item.productId.sku, price: formatNumber(item.price) })),
          type: 'ARRAY',
          value: 'quantity',
          extraValues: ['sku', 'price']
        },
        // {
        //   label: 'Products',
        //   data: primarySales && primarySales.product,
        //   field: 'productId.name',
        //   field2: 'productId.sku',
        // },
      ])
    }
  }, [primarySales])

  return (
    <Layout heading="Primary Sales" heading2="Info" url1={ROUTES.PRIMARY_SALES} none>
      {!loading ? (
        <HeaderTabLayout
          heading="Primary Sales"
          content={<CustomViewForm data={data} />}
          view
        // url={`/edit-primary-sales/${params.primarySalesId}`}
        />
      ) : (
        <Loader />
      )}
    </Layout>
  )
}
